import { ReactNode, useEffect, useState } from 'react'
import { MissingLocales, MoonLoader } from 'common/components'
import { logger } from 'services'

import loadTranslations from './app/services/i18n'

interface IProps {
  children: ReactNode
}

export default function TranslationsWrapper({ children }: IProps) {
  const [isTranslationReady, setIsTranslationReady] = useState(false)
  const [isError, setIsError] = useState(false)

  useEffect(() => {
    loadTranslations()
      .then(() => setIsError(false))
      .catch((err) => {
        setIsError(true)
        logger.showErrorLog(`Error with loading translations: ${err}`)
      })
      .finally(() => setIsTranslationReady(true))
  }, [])

  if (isError && isTranslationReady) {
    return <MissingLocales />
  }

  if (!isError && !isTranslationReady) {
    return (
      <div className={'flex items-center justify-center h-screen w-screen'}>
        <MoonLoader />
      </div>
    )
  }

  return children
}
